
// Types
export interface StateProps {
  packageVersion: {
    latest: null | string,
    current: null | string,
    needUpdate: boolean,
  }
}

export const initialState: StateProps = {

  packageVersion: {
    latest: null,
    current: null,
    needUpdate: false,
  }
}